import { useCallback, useEffect } from 'react';
import { UserActions } from '../redux/UserActions';
import { removeAllAuthenticationKeysFromLocalStorage } from '../helpers/authenticationHelper';
import { redirectUrl } from '../common/constants';
import { useAppDispatch } from '../redux/store';
export const useAuthCallback = () => {
	const dispatch = useAppDispatch();
	const loadingUserStateBeaconCallback = useCallback(
		(loading: boolean) => {
			return dispatch(UserActions.saveUserBeaconLoading(loading));
		},
		[dispatch]
	);
	const verifyProfileLogin = useCallback(() => {
		return dispatch(
			UserActions.getUserProfileBeaconLogin({
				origin: 'login',
				status: undefined
			})
		);
	}, [dispatch]);

	const verifyProfileRegister = useCallback(() => {
		return dispatch(
			UserActions.getUserProfileBeaconLogin({
				origin: 'register',
				status: undefined
			})
		);
	}, [dispatch]);

	const verifyLogout = useCallback(() => {
		localStorage.removeItem(redirectUrl);
		removeAllAuthenticationKeysFromLocalStorage();
	}, []);

	useEffect(() => {
		window.addEventListener('beacon-loading-state', () => loadingUserStateBeaconCallback(true));
		window.addEventListener('iris-check-profile-register', verifyProfileRegister);
		window.addEventListener('iris-check-profile-login', verifyProfileLogin);
		window.addEventListener('beacon-logout', verifyLogout);
		return () => {
			window.removeEventListener('iris-check-profile-register', verifyProfileRegister);
			window.removeEventListener('beacon-loading-state', () =>
				loadingUserStateBeaconCallback(true)
			);
			window.removeEventListener('iris-check-profile', verifyProfileLogin);
			window.removeEventListener('beacon-logout', verifyLogout);
		};
	}, []);
};
